import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import GlobalStyle from './styles/global';
import Routes from './routes';
import Header from './components/Header';

function App() {
  const queryClient = new QueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Header />
          <Routes />
        </BrowserRouter>
      </QueryClientProvider>
      <GlobalStyle />
      <ToastContainer autoClose={5000} />
    </>
  );
}

export default App;
